import api from './api'
import { defActionSlice } from '../../../../helpers/defaultAction'
import { predictivePriceReducer } from './reducer'

const {
    setLoading,
    setError,
    getListSuccess,
    clear
} = predictivePriceReducer.actions

export const getPredictivePrice = (values) => {
	const defObj = {
		req: setLoading,
		suc: getListSuccess,
		fail: setError,
		service: {
			params: values,
			func: api.getList
		}
	}
	return defActionSlice(defObj)
}

export const clearAction = (values) => {
	const defObj = {
		req: clear,
	}
	return defActionSlice(defObj)
}
